import React, { ReactNode } from 'react';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';

import styles from './Button.module.scss';

interface ButtonProps {
  children: ReactNode;
  className?: string | null;
  hasInitialFocus?: boolean;
  focusId?: string | number | null;
  onClick?: () => void;
  onFocusSet?: (hasFocus: boolean) => void;
  ttsText: string;
  [key: string]: unknown;
}

const Button = ({
  children,
  className = null,
  hasInitialFocus = false,
  focusId = null,
  onClick = () => {},
  onFocusSet = () => {},
  ttsText,
  ...rest
}: ButtonProps) => {
  return (
    <Selectable
      onSelect={onClick}
      hasInitialFocus={hasInitialFocus}
      focusId={focusId}
      onFocusSet={onFocusSet}
      ttsText={ttsText}
      render={({ hasFocus }) => (
        <button
          type="button"
          className={classNames(
            styles.button,
            className,
            hasFocus ? styles.focused : styles.unfocused,
          )}
          onClick={onClick}
          {...rest}
        >
          {children}
        </button>
      )}
    />
  );
};

const MemoizedButton = React.memo(Button);
MemoizedButton.displayName = 'Button';

export default MemoizedButton;
